const en_US = {
  Name: 'Name'
};

export default en_US;
